import * as types from "../constants";

export const closeModal = () => ({
    type: types.SOCKET_MODAL_CLOSE,
});
